'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.clearAllInfo = exports.removeAllArea = exports.removeSingleArea = exports.removeAreaInfo = exports.addAreaInfo = exports.addArea = exports.removeTyphoonpot = exports.modifyTyphoonspot = exports.addTyphoonspot = exports.getTyphoonspot = undefined;

var _typhoon = require('../typhoon');

var _url = require('../util/url.conf');

var _overlay = require('../util/overlay');

var overlay = _interopRequireWildcard(_overlay);

var _typhoonDom = require('../typhoonDom');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var _areas = {};

var _lines = ['firstTyLine', 'secondTyLine', 'thirdTyLine'];
var _divIcons = ['firstTipDiv', 'secondTipDiv', 'thirdTipDiv'];
var _classNames = ['distance-iconOne', 'distance-iconTwo', 'distance-iconThree'];
var _allLayerId = ['firstTyLine', 'secondTyLine', 'thirdTyLine', 'firstTipDiv', 'secondTipDiv', 'thirdTipDiv'];

var addCircle = function addCircle(lat, lon, radius, pointId) {
  var opts = {
    fillOpacity: 0.3,
    weight: 1,
    renderer: areaRenderer
  };
  var colors = [{
    color: '#adb7c3',
    fillColor: '#adb7c3'
  }, {
    color: '#C18BA5',
    fillColor: '#C18BA5'
  }, {
    color: '#C6987E',
    fillColor: '#C6987E'
  }, {
    color: '#BCAF83',
    fillColor: '#BCAF83'
  }, {
    color: '#83CECB',
    fillColor: '#83CECB'
  }, {
    color: '#fcc',
    fillColor: '#fcc'
  }, {
    color: '#aaa',
    fillColor: '#aaa'
  }, {
    color: '#428CD5',
    fillColor: '#428CD5'
  }, {
    color: '#fff',
    fillColor: '#fff'
  }];
  var colorsLen = radius.length - 1;
  radius.map(function (r, index) {
    var circle = L.circle([lat, lon], r * 1000, Object.assign({}, opts, colors[colorsLen - index]));
    circle.id = 'circle';
    circle.addTo(map);
    _areas[pointId].layers.circle.push(circle);
  });
};
var addCenterPoint = function addCenterPoint(point, pointId, bool, pData) {
  var icon = L.divIcon({
    className: 'warnPonit',
    html: '<div class="' + (bool ? 'warn_point_on' : 'warn_point') + '"><div></div><div></div><div></div></div>'
  });
  var events = {
    click: function click(e) {
      $('#waveHeight').text(pData.waveHeight ? pData.waveHeight + 'm' : '---');
      $('#waveDir').text(pData.waveDir ? pData.waveDir : '---');
      $('#wavePeriod').text(pData.waveProid ? pData.waveProid + 's' : '---');
      $('#windPowers').text(pData.windPower ? pData.windPower + '级' : '---');
      $('#stormSurge').text(pData.windWater ? pData.windWater : '---');
      $('#windDirs').text(pData.windDirection ? pData.windDirection : '---');


      if ($('.simiMatch.on').length) $('.closeSimi').click();
      $('.early_head').attr('pointid', pointId);
      map.addEventListener('movestart', _typhoonDom.hidePreWarnPopup);
      map.addEventListener('click', _typhoonDom.hidePreWarnPopup);
      $('.tycontener_bottSeawave').stop().animate({
        'bottom': '-6rem'
      });
      $('.early_warn').addClass('on').stop().animate({
        bottom: '0rem'
      });
      $('.imgEx,.tyCl_list,.cloudPopup').stop().animate({
        'bottom': 4.4 + 'rem'
      });
    }
  };
  var marker = L.marker(point, {
    icon: icon
  });
  for (var ev in events) {
    marker.on(ev, events[ev]);
  }marker.id = 'centerPoint';
  marker.addTo(map);
  _areas[pointId].layers.centerPoint = marker;
};
var getSelectTyIndex = function getSelectTyIndex() {
  var arr = [];
  $('#tyChangeWraper .layer-selected').map(function () {
    var index = $(this).index();
    arr.push(index);
  });
  return arr;
};
var addPolyline = function addPolyline(point, arr, pointId) {
  console.log("addPolyline", point, arr, pointId);
  var opts = {
    color: 'red',
    weight: 2,
    dashArray: '4, 5',
    dashOffset: '2',
    renderer: areaRenderer
  };
  arr.map(function (i) {
    var latlngs = [point, _typhoon.tyCenter[i]];
    var polyline = L.polyline(latlngs, opts);
    polyline.id = _lines[i];
    polyline.addTo(map);
    _areas[pointId].layers.polyline.push(polyline);
  });
};
var addDistance = function addDistance(point, arr, pointId) {
  arr.map(function (i) {
    var distance = L.latLng(_typhoon.tyCenter[i]).distanceTo(point);
    distance = (distance / 1000).toFixed(2) + '公里';
    _areas[pointId].distances[i] = distance;
  });
};
var addDivIcon = function addDivIcon(point, arr, pointId) {
  arr.map(function (i) {
    var tyName = $('#tyChange li').eq(i).find('a').text();
    var distance = _areas[pointId].distances[i];
    var opts = L.divIcon({
      className: '' + _classNames[i],
      html: '<div class="distanceIcon"><span></span><span>\u8DDD\u79BB' + tyName + '\u53F0\u98CE\u4E2D\u5FC3' + distance + '</span></div>'
    });
    var divIcon = L.marker(point, {
      icon: opts
    });
    divIcon.id = _divIcons[i];
    divIcon.addTo(map);
    _areas[pointId].layers.divIcon.push(divIcon);
  });
};

var getTyphoonspot = exports.getTyphoonspot = function getTyphoonspot() {
  var userId = window.locationInfo.userId;
  var url = _url._tyUrl.obtain();
  return $.post({
    url: url,
    dataType: 'json',
    data: {
      userId: userId
    }
  });
};
var addTyphoonspot = exports.addTyphoonspot = function addTyphoonspot(lat, lon, radius) {
  var userId = window.locationInfo.userId;
  var url = _url._tyUrl.add();
  var params = {
    userId: userId,
    lon: lon,
    lat: lat,
    radius: radius
  };
  return $.post({
    url: url,
    dataType: 'json',
    data: params
  });
};
var modifyTyphoonspot = exports.modifyTyphoonspot = function modifyTyphoonspot(lat, lon, radius, typhoonid) {
  var userId = window.locationInfo.userId;
  var url = _url._tyUrl.modify();
  var params = {
    userId: userId,
    lon: lon,
    lat: lat,
    radius: radius,
    typhoonid: typhoonid
  };
  return $.post({
    url: url,
    dataType: 'json',
    data: params
  });
};
var removeTyphoonpot = exports.removeTyphoonpot = function removeTyphoonpot(typhoonid) {
  var userId = window.locationInfo.userId;
  var url = _url._tyUrl.remove();
  var params = {
    userId: userId,
    typhoonid: typhoonid
  };
  return $.post({
    url: url,
    dataType: 'json',
    data: params
  });
};

var addArea = exports.addArea = function addArea(lat, lon, radius, pointId, bool, pData) {
  lat = Number(lat);
  lon = Number(lon);
  var point = [lat, lon];
  _areas[pointId] = {
    point: point,
    distances: {},
    layers: {
      circle: [],
      centerPoint: null,
      divIcon: [],
      polyline: []
    }
  };
  addCircle(lat, lon, radius, pointId);
  addCenterPoint(point, pointId, bool, pData);
  var selectedTyArr = getSelectTyIndex();
  addPolyline(point, selectedTyArr, pointId);
  addDistance(point, selectedTyArr, pointId);
  addDivIcon(point, selectedTyArr, pointId);
};

var addAreaInfo = exports.addAreaInfo = function addAreaInfo(i) {
  for (var key in _areas) {
    var area = _areas[key];

    if (!area.distances[i]) {
      var distance = L.latLng(_typhoon.tyCenter[i]).distanceTo(area.point);
      distance = (distance / 1000).toFixed(2) + '公里';
      area.distances[i] = distance;
    }

    var tyName = $('#tyChange li').eq(i).find('a').text();
    var opts = L.divIcon({
      className: '' + _classNames[i],
      html: '<div class="distanceIcon"><span></span><span>\u8DDD\u79BB' + tyName + '\u53F0\u98CE\u4E2D\u5FC3' + area.distances[i] + '</span></div>'
    });
    var divIcon = L.marker(area.point, {
      icon: opts
    });
    divIcon.id = _divIcons[i];
    divIcon.addTo(map);
    _areas[key].layers.divIcon.push(divIcon);
  }
};

var removeAreaInfo = exports.removeAreaInfo = function removeAreaInfo(i) {
  map.eachLayer(function (layer) {
    if (layer.id === _lines[i] || layer.id === _divIcons[i]) map.removeLayer(layer);
  });
};

var removeSingleArea = exports.removeSingleArea = function removeSingleArea(pointId) {
  for (var layer in _areas[pointId].layers) {
    var l = _areas[pointId].layers[layer];
    if (Array.isArray(l)) {
      l.map(function (item) {
        map.removeLayer(item);
      });
    } else map.removeLayer(l);
  }
  delete _areas[pointId];
};

var removeAllArea = exports.removeAllArea = function removeAllArea() {
  map.eachLayer(function (layer) {
    if (_allLayerId.indexOf(layer.id) !== -1) map.removeLayer(layer);
  });
  for (var key in _areas) {
    _areas[key].layers.polyline = [];
    _areas[key].layers.divIcon = [];
  }
};

var clearAllInfo = exports.clearAllInfo = function clearAllInfo() {
  for (var id in _areas) {
    removeSingleArea(id);
  }
};


//////////////////
// WEBPACK FOOTER
// ./js/business/alarmArea.js
// module id = 21
// module chunks = 0